import { RunQueueFilters } from '../utils/types'

export function getToken() {
  const tokenString: string | null = localStorage.getItem('wivi.access_token')
  return tokenString == null ? '' : tokenString.replace(/['"]+/g, '')
}
export function getUser() {
  const wiviUser: string | null = localStorage.getItem('wivi.user')
  const userString =
    wiviUser === null ? '{}' : wiviUser.substring(1, wiviUser.length - 1)
  const user = JSON.parse(userString.replace(/\\/g, ''))
  return user
}

export const searchResults = async queryJsonString => {
  //TODO need elegant way of store and retrieve token and user info

  const token = getToken()
  const keys = Object.keys(queryJsonString)
  let queryStr = '?'
  keys.forEach(key => {
    queryStr = `${queryStr}${key}=${queryJsonString[key]}&`
  })

  const res = await fetch('../ipa/result/search' + queryStr, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  if (res.status === 401) {
    window.location.href = '/ui/#!/'
  }

  return res.json()
}

export const loadAnalyzers = async () => {
  //TODO need elegant way of store and retrieve token and user info

  const token = getToken()
  const res = await fetch('/ipa/analyzer', {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  if (res.status === 401) {
    window.location.href = '/ui/#!/'
  }

  return res.json()
}

export const loadFleets = async () => {
  //TODO need elegant way of store and retrieve token and user info

  const token = getToken()
  const res = await fetch('/api/v1/fleets', {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  if (res.status === 401) {
    window.location.href = '/ui/#!/'
  }

  const resArray = await res.json()
  return resArray.map(fleet => {
    fleet.vehicles = fleet.vehicles.filter(vehicle => {
      return !vehicle.deleteFlag
    })
    return fleet
  })
}

export const loadDataSets = async () => {
  //TODO need elegant way of store and retrieve token and user info

  const token = getToken()
  const res = await fetch('/ipa/dataset', {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  if (res.status === 401) {
    window.location.href = '/ui/#!/'
  }

  return res.json()
}

export const loadConfigurations = async (scriptId: string) => {
  //TODO need elegant way of store and retrieve token and user info

  const token = getToken()
  const res = await fetch(`/ipa/script/${scriptId}/config`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  if (res.status === 401) {
    window.location.href = '/ui/#!/'
  }

  return res.json()
}

export const searchQueue = async (
  queryJsonString: string | RunQueueFilters
) => {
  //TODO need elegant way of store and retrieve token and user info

  const token = getToken()
  const res = await fetch('/ipa/job/search', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },

    //TODO passing body with query json
    body: JSON.stringify(queryJsonString),
  })

  if (res.status === 401) {
    window.location.href = '/ui/#!/'
  }

  return res.json()
}

export const listOrgsByUser = async (queryJsonString: string) => {
  //TODO need elegant way of store and retrieve token and user info

  const token = getToken()
  const res = await fetch('/api/organization/listOrgsByUser', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
    //TODO passing body with query json
    body: JSON.stringify(queryJsonString),
  })

  if (res.status === 401) {
    window.location.href = '/ui/#!/'
  }

  return res.json()
}

export const uploadScript = async queryJsonString => {
  //TODO need elegant way of store and retrieve token and user info
  const token = getToken()
  const res = await fetch(`/ipa/script`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
    //TODO passing body with query json
    body: JSON.stringify(queryJsonString),
  })

  if (res.status === 401) {
    window.location.href = '/ui/#!/'
  }

  return res.json()
}

export const getScripts = async () => {
  //TODO need elegant way of store and retrieve token and user info

  const token = getToken()
  const res = await fetch('/ipa/script', {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  if (res.status === 401) {
    window.location.href = '/ui/#!/'
  }

  return res.json()
}

export const uploadConfig = async (id: string, data) => {
  //TODO need elegant way of store and retrieve token and user info
  const token = getToken()
  const res = await fetch(`/ipa/script/${id}/config`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
    //TODO passing body with query json
    body: JSON.stringify(data),
  })

  if (res.status === 401) {
    window.location.href = '/ui/#!/'
  }

  return res.json()
}

export const cancelRunQueue = async (ids: number[] | null) => {
  //TODO need elegant way of store and retrieve token and user info

  const token = getToken()
  const res = await fetch('/ipa/job', {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
    //TODO passing body with query json
    body: JSON.stringify({ ids }),
  })
    .then(response => response.text())
    .then(data => Promise.resolve(data ? JSON.parse(data) : {}))

  if (res.status === 401) {
    window.location.href = '/ui/#!/'
  }

  return res.json()
}

export const deleteRunQueue = async (ids: string[] | null) => {
  //TODO need elegant way of store and retrieve token and user info

  const token = getToken()
  const res = await fetch('/ipa/job/remove/', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
    //TODO passing body with query json
    body: JSON.stringify({ ids }),
  })
    .then(response => response.text())
    .then(data => Promise.resolve(data ? JSON.parse(data) : {}))

  if (res.status === 401) {
    window.location.href = '/ui/#!/'
  }

  return res.json()
}

export const generateAnalyzer = async (queryJson, currentAnalyzer) => {
  //TODO need elegant way of store and retrieve token and user info

  const token = getToken()
  const method = currentAnalyzer === null ? 'POST' : 'PUT'
  let url = '/ipa/analyzer'
  if (currentAnalyzer !== null) {
    url = url + '/' + currentAnalyzer.id
  }
  const res = await fetch(url, {
    method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
    //TODO passing body with query json
    body: JSON.stringify(queryJson),
  })

  if (res.status === 401) {
    window.location.href = '/ui/#!/'
  }

  return res.json()
}

export const runAnalyzer = async queryJson => {
  //TODO need elegant way of store and retrieve token and user info

  const token = getToken()
  const res = await fetch('/ipa/job', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
    //TODO passing body with query json
    body: JSON.stringify(queryJson),
  })

  if (res.status === 401) {
    window.location.href = '/ui/#!/'
  }

  return res.json()
}

export const deleteAnalyzer = async (id: string) => {
  //TODO need elegant way of store and retrieve token and user info

  const token = getToken()
  const res = await fetch('/ipa/analyzer/' + id, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  if (res.status === 401) {
    window.location.href = '/ui/#!/'
  }

  return res.json()
}

export const reloadPermissions = async () => {
  //TODO need elegant way of store and retrieve token and user info
  const token = getToken()
  const res = await fetch('/api/v1/currentUser', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  if (res.status === 401) {
    window.location.href = '/ui/#!/'
  }

  return res.json()
}

export const downloadResultsSelections = async fileInfo => {
  //TODO need elegant way of store and retrieve token and user info

  const token = getToken()
  const res = await fetch('/api/ipa/results/download/', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
    body: JSON.stringify({
      fileInfo,
      // TODO need to change from hard-coded timezone
      timezoneOffset: '-0600 America/Chicago',
    }),
  })

  if (res.status === 401) {
    window.location.href = '/ui/#!/'
  }

  return res.json()
}

export const getUserDownloadToken = async (type: string, id: number) => {
  //TODO need elegant way of store and retrieve token and user info

  const token = getToken()
  const res = await fetch(`/api/v1/downloader/request?type=${type}&id=${id}`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  if (res.status === 401) {
    window.location.href = '/ui/#!/'
  }

  return res.json()
}

export const deleteDataSets = async (id: number) => {
  //TODO need elegant way of store and retrieve token and user info

  const token = getToken()
  const res = await fetch('/ipa/dataSets/' + id, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  if (res.status === 401) {
    window.location.href = '/ui/#!/'
  }

  return res.json()
}

export const deleteScript = async (id: string) => {
  //TODO need elegant way of store and retrieve token and user info

  const token = getToken()
  const res = await fetch(`/ipa/script/${id}/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  if (res.status === 401) {
    window.location.href = '/ui/#!/'
  }
}

export const retrieveDownload = async (downloadToken: string) => {
  //TODO need elegant way of store and retrieve token and user info

  const token = getToken()
  const res = await fetch(
    `/api/v1/downloader/retrieve?token=${downloadToken}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + token,
      },
    }
  )

  if (res.status === 401) {
    window.location.href = '/ui/#!/'
  }

  return res.json()
}

export const listUsersInOrganization = async () => {
  //TODO need elegant way of store and retrieve token and user info
  const token = getToken()
  const res = await fetch('/api/v1/users/listUsersInOrganization', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  if (res.status === 401) {
    window.location.href = '/ui/#!/'
  }

  return res.json()
}

export const generateFilter = async queryJson => {
  //TODO need elegant way of store and retrieve token and user info
  const token = getToken()
  const res = await fetch('/api/ipa/filters', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
    body: JSON.stringify(queryJson),
  })

  if (res.status === 401) {
    window.location.href = '/ui/#!/'
  }

  return res.json()
}

export const getCurrentUser = async (accessToken: string | null) => {
  //TODO need elegant way of store and retrieve token and user info
  const token = accessToken != null ? accessToken.replace(/['"]+/g, '') : getToken()
  const res = await fetch('/api/v1/currentUser', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  // Routes back to new login form if not logged in and trying to access new UI pages
  if (res.status === 401 && window.location.pathname !== '/ui2/login') {
    window.location.href = '/ui2/login'
  }

  return res.json()
}

export const addMultipleRunResults = async payload => {
  //TODO need elegant way of store and retrieve token and user info
  const token = getToken()
  const res = await fetch('/api/ipa/results/addMultipleRunResults/', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
    body: JSON.stringify(payload),
  })

  if (res.status === 401) {
    window.location.href = '/ui/#!/'
  }

  return res.json()
}

export const removeRunResults = async payload => {
  //TODO need elegant way of store and retrieve token and user info
  const token = getToken()
  const res = await fetch('/api/ipa/runResult/remove', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
    body: JSON.stringify(payload),
  })

  if (res.status === 401) {
    window.location.href = '/ui/#!/'
  }

  return res.json()
}

export const generateDataSet = async (queryJson, currentDataSet) => {
  //TODO need elegant way of store and retrieve token and user info

  const token = getToken()
  const method = currentDataSet === null ? 'POST' : 'PUT'
  let url = '/ipa/dataset'

  if (currentDataSet !== null) {
    url = url + '/' + currentDataSet.id
  }

  const res = await fetch(url, {
    method: method,
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
    //TODO passing body with query json
    body: JSON.stringify(queryJson),
  })

  if (res.status === 401) {
    window.location.href = '/ui/#!/'
  }

  return res.json()
}

export const searchDataSets = async (queryJson, countOnly: boolean) => {
  //TODO need elegant way of store and retrieve token and user info

  const token = getToken()
  const res = await fetch('/api/v1/data/search', {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },

    //TODO passing body with query json
    body: JSON.stringify(queryJson),
  })

  if (res.status === 401) {
    window.location.href = '/ui/#!/'
  }
  if (countOnly) {
    return res.headers.get('x-wivi-total')
  }

  return res.json()
}

export const loadCollections = async (queryString: string) => {
  //TODO need elegant way of store and retrieve token and user info

  const token = getToken()
  const res = await fetch('/api/v1/data/collections?' + queryString, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  if (res.status === 401) {
    window.location.href = '/ui/#!/'
  }

  if(res.status == 400){
    return []
  }

  return res.json()
}

export const getConfigs = async (id: string) => {
  //TODO need elegant way of store and retrieve token and user info

  const token = getToken()
  const url = `/ipa/script/${id}/config/`
  const res = await fetch(url, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  if (res.status === 401) {
    window.location.href = '/ui/#!/'
  }

  return res.json()
}

export const loadScriptNameSet = async () => {
  //TODO need elegant way of store and retrieve token and user info
  const token = getToken()
  const res = await fetch('/api/v1/downloadFile/scriptNameSet', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
    //TODO passing body with query json
    body: JSON.stringify({}),
  })

  if (res.status === 401) {
    window.location.href = '/ui/#!/'
  }

  return res.json()
}

export const loadExtensions = async (queryString: string): Promise<string[]> => {
  //TODO need elegant way of store and retrieve token and user info
  const token = getToken()
  const res = await fetch('/api/v1/data/extensions?' + queryString, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  if (res.status === 401) {
    window.location.href = '/ui/#!/'
  }

  if(res.status == 400){
    return []
  }

  return res.json() as Promise<string[]>
}

export const deleteConfig = async (id: string) => {
  //TODO need elegant way of store and retrieve token and user info
  const token = getToken()
  const res = await fetch(`/ipa/script/NEED_SCRIPT_ID/config/${id}/`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
  })

  if (res.status === 401) {
    window.location.href = '/ui/#!/'
  }
}

export const editConfig = async (id: string, data) => {
  //TODO need elegant way of store and retrieve token and user info
  const token = getToken()
  const res = await fetch(`/ipa/script/config/${id}`, {
    method: 'PUT',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + token,
    },
    //TODO passing body with query json
    body: JSON.stringify(data),
  })

  if (res.status === 401) {
    window.location.href = '/ui/#!/'
  }

  return res.json()
}

export const useRefreshToken = async (token: string) => {
  const urlencoded = new URLSearchParams()
  urlencoded.append('grant_type', 'refresh_token')
  urlencoded.append('refresh_token', token)
  const res = await fetch(`/api/oauth/access_token`, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: urlencoded,
    redirect: 'follow',
  })
  return res.json()

}
